import { useLocation } from '@reach/router';

const isDev = process.env.NODE_ENV === 'development';

export function useRouteSection(): string {
  const location = useLocation();
  const paths = location.pathname.split('/');

  // local: /onemedical/[takaful]/quotation
  // remote: /edp/life/onemedical/[takaful]/quotation
  return paths[isDev ? 2 : 4];
}

export function useGetHost() {
  return useLocation().host;
}

export function useProductType(): string {
  const location = useLocation();
  const paths = location.pathname.split('/');

  // local: /onemedical/[takaful]/quotation
  // remote: /edp/life/onemedical/[takaful]/quotation
  return paths[isDev ? 1 : 3];
}

export function useOrigin() {
  const location = useLocation();
  return location.host;
}
